import { TUPLE_COLORS } from '../config/tupleTheme'

const MultiAirlineIcon: React.FC<{ size: number }> = ({ size }) => (
  <svg aria-hidden fill='none' height={size} viewBox='0 0 32 32' width={size} xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' fill={TUPLE_COLORS.linkLightBg} r='16' />
    <path
      d='M22.8 9.2c-.55-.55-1.45-.55-2 0l-2.6 2.6-5.85-1.5c-.35-.1-.7.05-.9.35l-.55.55c-.3.3-.25.75.1 1l4.55 3.15-2.35 2.35-1.25-.2c-.25-.05-.5.05-.65.25l-.55.55c-.25.25-.2.65.1.85l1.7.85.85 1.7c.2.3.6.35.85.1l.55-.55c.2-.15.3-.4.25-.65l-.2-1.25 2.35-2.35 3.15 4.55c.25.35.7.4 1 .1l.55-.55c.3-.2.45-.55.35-.9l-1.5-5.85 2.6-2.6c.55-.55.55-1.45 0-2z'
      fill={TUPLE_COLORS.link}
    />
  </svg>
)

export default MultiAirlineIcon
